export default {
  template: '<i class="n-i n-i-question"></i>'
};
